import React from 'react';
import PropTypes from 'prop-types';
import Customers from 'components/customers/Customers';
import CustomerFilterValues from 'components/customers/CustomerFilterValues';
import CustomerPreviewDetailsModal from 'components/customers/CustomerPreviewDetailsModal';

export default function PartnerCustomersTab({ partnerId }) {
  return (
    <>
      <CustomerFilterValues />
      <Customers partnerId={partnerId} preFilterByPartner={true} />
      <CustomerPreviewDetailsModal />
    </>
  );
}

PartnerCustomersTab.propTypes = {
  partnerId: PropTypes.string.isRequired,
};
